// レビューの匿名アイコン&名前を消す judge.me 本名問題の対策。24/10/23
//var elems1 = document.getElementsByClassName('jdgm-rev__icon');
//
//var len1 = elems1.length;
//for (var i = 0; i < len1; i++) {
//
//    var e = elems1[0];
//    e.parentNode.removeChild(e);
//}

var elems2 = document.getElementsByClassName('jdgm-rev__author');

var len2 = elems2.length;
for (var i = 0; i < len2; i++) {

    var e = elems2[0];
    e.parentNode.removeChild(e);
}